/* global fbq */

import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Modal, Slider } from "antd";
import { VideoPlayer } from "../competition/Submission/VideoPlayer";
import { sliderValueToVideoTime } from "../competition/Submission/sliderValueToVideoTime";
import { setContribution } from "../../store/asyncMethods/AuthMethods";
import { WebSocketContext } from "../../WebSocket";
import axios from "axios";
import { ENV, path } from "../../path";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ReactGA from 'react-ga4'
import { EventTypes, trackEvent } from "../../Utils/Analytics";
import LockIcon from '@mui/icons-material/Lock';
import { PercentageBadge, RazorpayText } from "./icons";
import CryptoJS from "crypto-js";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { redirectToStore } from "../../Utils/genralUtility";

const SubmissionUploadModal = (props) => {
  const {
    isOpen,
    onClose,
    maxVideoLength = 3,
    contestId,
    submission,
    setSubmission,
    contestFee,
    paymentType,
    participationLimit,
    registeredLength,
    submissionInfo,
    paymentHandler,
    slotFinalPaymentHandler,
    slotFeePercentage,
    processingPayment,
    uploadConfig,
    activeDiscount
  } = props

  const maxVideoLengthInMinutes = useMemo(() => {
    const seconds = maxVideoLength * 60;
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;

    // Padding zero if necessary
    if (remainingSeconds < 10) {
      remainingSeconds = "0" + remainingSeconds;
    }

    return minutes + ":" + remainingSeconds;
  }, [maxVideoLength])
  const maxVideoLengthInWords = useMemo(() => {
    const maxMinutes = Math.floor((maxVideoLength * 60) / 60);
    const maxSeconds = Math.round((maxVideoLength * 60) % 60);

    return maxMinutes
      ? `${maxMinutes} minute${maxMinutes > 1 ? 's' : ''} ${maxSeconds ? `and ${maxSeconds} second${maxSeconds > 1 ? 's' : ''}` : ''}`
      : `${maxSeconds} second${maxSeconds > 1 ? 's' : ''}`;
  }, [maxVideoLength]);

  const { user, token } = useSelector((state) => state.AuthReducer);
  // const MAX_RETRIES = 3;
  const dispatch = useDispatch();
  const socket = useContext(WebSocketContext);

  const [videoFile, setVideoFile] = useState(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [sliderValues, setSliderValues] = useState([0, 100]);
  const [isVideoLengthError, setIsVideoLengthError] = useState(false);
  const [finalPercentage, setFinalPercentage] = useState(0);
  const [isVideoUploaded, setIsVideoUploaded] = useState(false);
  const [submissionUploading, setSubmissionUploading] = useState(false);
  const [accessToken, setAccessToken] = useState(null);

  const submissionGuidelines = [
    {
      text: "Make sure lightning is good",
      icon: WbSunnyIcon
    },
    {
      text: "You will get a chance to trim & reupload video if necessary by you",
      icon: ContentCutIcon
    },
    {
      text: `Video Length Limit: Keep your video recording to a maximum of ${maxVideoLengthInWords || '3 minutes'}`,
      icon: AccessTimeIcon
    },
  ]

  const videoPlayerRef = useRef();
  const loadTimeoutRef = useRef();
  const validateTimeoutRef = useRef();

  useEffect(() => {
    socket.on('subpercentage', (data) => {
      console.log('connected')
      setFinalPercentage(() => {
        console.log(70 + (data.percentage * 0.3), "backend")
        return (Math.floor(70 + (data.percentage * 0.3)))
      });
    });

    return (() => {
      socket.off('subpercentage')
      console.log('disconnected')
    })
  }, [socket])

  const formatter = (val) => {
    const seconds = sliderValueToVideoTime(videoDuration, val);
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;

    // Padding zero if necessary
    if (remainingSeconds < 10) {
      remainingSeconds = "0" + remainingSeconds;
    }

    return minutes + ":" + remainingSeconds;
  }

  const validateVideoLength = (values) => {
    if (validateTimeoutRef.current) {
      clearTimeout(validateTimeoutRef.current);
    }
    validateTimeoutRef.current = setTimeout(() => {
      const min = sliderValueToVideoTime(videoDuration, values[0]);
      const max = sliderValueToVideoTime(videoDuration, values[1]);
      setIsVideoLengthError((max - min) > (maxVideoLength * 60))
    }, 200);
  }

  const SilderCal = (values) => {
    validateVideoLength(values)
    setSliderValues((prev) => {
      // reloading the video when we are changing startTime
      if (prev[0] !== values[0] && videoPlayerRef.current) {
        if (loadTimeoutRef.current) {
          clearTimeout(loadTimeoutRef.current);
        }
        loadTimeoutRef.current = setTimeout(() => {
          videoPlayerRef.current?.load();
        }, 200);
      }

      return values
    })
  }

  const removeVideoHandler = () => {
    setVideoFile(null);
    setSliderValues([0, 100]);
    setIsVideoLengthError(false);
    setVideoDuration(0);
  }

  const readChunkAsBase64 = (blobChunk) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        // reader.result = "data:...;base64,..."
        const base64 = reader.result.split(',')[1]; // remove data URL prefix
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blobChunk);
    });
  };

  // const uploadChunk = async (chunk, index, retries = 0, name) => {
  //     try {
  //         await axios.post(`${path}/contest/chunkUpload`, {
  //             chunk,
  //             index,
  //             fileId: name,
  //         });
  //     } catch (error) {
  //         if (retries < MAX_RETRIES) {
  //             console.log(
  //             `Retrying chunk ${index}, attempt ${retries + 1} ${error}`
  //             );
  //             await uploadChunk(chunk, index, retries + 1, name);
  //         } else {
  //             throw new Error(
  //             `Failed to upload chunk ${index} after ${MAX_RETRIES} retries`
  //             );
  //         }
  //     }
  // };

  // const uploadvideoFileInChunks = async () => {
  //   const { chunkSize: CHUNK_SIZE, uploadSpeed } = uploadConfig;
  //   if(ENV === "prod") {
  //     trackEvent(EventTypes.UPLOAD_SPEED, { uploadSpeed })
  //   }

  //   const totalChunks = Math.ceil(videoFile.size / CHUNK_SIZE);
  //   let uploadedChunks = 0;
  //   let name = `FeedAnts_UsrId_${user._id}_CntstId_${contestId}_${Date.now()}`;

  //   setSubmissionUploading(true);
  //   console.log(typeof videoFile);
  //   console.log(videoFile);
  //   for (let i = 0; i < totalChunks; i++) {
  //     const start = i * CHUNK_SIZE;
  //     const end = start + CHUNK_SIZE;
  //     const chunkBlob = videoFile.slice(start, end);
  //     const chunkBase64 = await readChunkAsBase64(chunkBlob);

  //     try {
  //       await uploadChunk(chunkBase64, uploadedChunks, 0, name);
  //       uploadedChunks++;
  //       console.log(uploadedChunks);
  //       console.log(
  //         Math.round(Math.round((uploadedChunks / totalChunks) * 100) * 0.7),
  //         "chunk"
  //       );
  //       setFinalPercentage(
  //         Math.round(Math.round((uploadedChunks / totalChunks) * 100) * 0.7)
  //       );
  //     } catch (error) {
  //       console.error("Error uploading video:", error);
  //       throw new Error(error);
  //     }
  //   }

  //   const [min, max] = sliderValues;
  //   const minTime = sliderValueToVideoTime(videoDuration, min);
  //   const maxTime = sliderValueToVideoTime(videoDuration, max);

  //   const config = {
  //     host: `${path}`,
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": `${path}`,
  //       Authorization: `Bearer ${token}`,
  //     },
  //   };

  //   try {
  //     const body = {
  //       startTime: minTime,
  //       endTime: maxTime,
  //       filename: name,
  //       userId: user?._id,
  //       contestId: contestId,
  //       platform: "web",
  //     };

  //     const response = await axios.post(
  //       `${path}/contest/createSubmission`,
  //       body,
  //       config
  //     );

  //     socket.emit("contest-submitted", user);
  //     dispatch(setContribution(contestId));
  //     console.log(response, "trim vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv");
  //     if (response.status === 200) {
  //       console.log("submission done");
  //       toast.success("Video Uploaded Successfully!");
  //       setIsVideoUploaded(true);
  //       setSubmission(response.data.submission);
  //       if (ENV === "prod") {
  //         ReactGA.event("submission_done", {
  //           user_id: user._id,
  //           submission_id: response.data.submission._id,
  //         });
  //         fbq("trackCustom", "submission_done", {
  //           user_id: user._id,
  //           submission_id: response.data.submission._id,
  //           email: user?.email || "",
  //           currency: "INR",
  //           value: contestFee,
  //         });
  //       }
  //       // onClose();
  //     }
  //   } catch (e) {
  //     toast.error("Error uploading video, please try again!");
  //     console.error("Error uploading video: " + JSON.stringify(e));
  //   } finally {
  //     setSubmissionUploading(false);
  //     setFinalPercentage(0);
  //   }
  //   // Notify the backend that the upload is complete
  //   // await axios.post(`${path}/contest/upload-complete`, { filename: name });
  // };

  const getAccessToken = async () => {
    if (accessToken) {
      return accessToken;
    } else {
      const res = await axios.get(`${path}/getUploadToken`);
      setAccessToken(res.data.accessToken);
      return res.data.accessToken;
    }
  };

  const generateUrl = async (id, name) => {
    // API endpoint for shared links here
    const res = await axios.post(`${path}/genrate-Url`, { id, name });
    return res.data;
  };

  const DirectSingleUpload = async (
    file,
    fileName,
  ) => {
    try {
      const accessToken = await getAccessToken();

      const formData = new FormData();
      formData.append("file", file, fileName);
      formData.append("parent_id", "0");

      const res = await axios.post(
        "https://upload.box.com/api/2.0/files/content",
        formData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (e) => {
            const percent = Math.round((e.loaded * 100) / e.total);
            setFinalPercentage(Math.round(percent * 0.9));
          },
        }
      );

      const fileData = res.data.entries[0];
      const { file_url, file_id } = await generateUrl(fileData.id, fileName);

      if (file_url && file_id) {
        const [min, max] = sliderValues;
        const minTime = sliderValueToVideoTime(videoDuration, min);
        const maxTime = sliderValueToVideoTime(videoDuration, max);

        const config = {
          host: `${path}`,
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": `${path}`,
            Authorization: `Bearer ${token}`,
          },
        };

        const body = {
          startTime: minTime,
          endTime: maxTime,
          userId: user?._id,
          boxUrl: file_url,
          boxId: file_id,
          contestId: contestId,
          platform: "web",
        };
        console.log(body)

        const response = await axios.post(
          `${path}/v2/contest/createSubmission`,
          body,
          config
        );
        socket.emit("contest-submitted", user);
        dispatch(setContribution(contestId));

        if (response.status === 200) {
          toast.success("Video Uploaded Successfully!");
          setIsVideoUploaded(true);
          setSubmission(response.data.submission);
          if (ENV === "prod") {
            ReactGA.event("submission_done", {
              user_id: user._id,
              submission_id: response.data.submission._id,
            });
            fbq("trackCustom", "submission_done", {
              user_id: user._id,
              submission_id: response.data.submission._id,
              email: user?.email || "",
              currency: "INR",
              value: contestFee,
            });
          }
        }
      }
    } catch (error) {
      toast.error("Error uploading video, please try again!");
      console.error("Error uploading video: " + JSON.stringify(error));
    }
  };

  const calculateSha1Digest = async (chunk) => {
    const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(chunk));
    const hash = CryptoJS.SHA1(wordArray).toString(CryptoJS.enc.Base64);

    return hash;
  };

  const DirectChunkUpload = async (file, fileName) => {
    try {
      const accessToken = await getAccessToken();
      const size = file.size;

      const { data: session } = await axios.post(
        "https://upload.box.com/api/2.0/files/upload_sessions",
        {
          folder_id: "0",
          file_size: size,
          file_name: fileName,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { id: sessionId, part_size: partSize } = session;

      const parts = [];
      let offset = 0;
      const overallSha1 = CryptoJS.algo.SHA1.create();

      while (offset < size) {
        const chunkBlob = file.slice(offset, offset + partSize);
        const base64 = await readChunkAsBase64(chunkBlob);
        const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

        overallSha1.update(CryptoJS.enc.Base64.parse(base64));
        const sha1Digest = await calculateSha1Digest(buffer);

        const { data: partResponse } = await axios.put(
          `https://upload.box.com/api/2.0/files/upload_sessions/${sessionId}`,
          buffer,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/octet-stream",
              "Content-Range": `bytes ${offset}-${offset + buffer.byteLength - 1}/${size}`,
              Digest: `sha=${sha1Digest}`,
            },
            onUploadProgress: (progressEvent) => {
              const progress = (((offset + progressEvent.loaded) / size) * 100).toFixed(2);
              setFinalPercentage((progress * 0.9).toFixed(2));
            },
          }
        );

        parts.push(partResponse.part);
        offset += buffer.byteLength;
      }

      const fullSha = overallSha1.finalize().toString(CryptoJS.enc.Base64);

      const { data: commitResponse } = await axios.post(
        `https://upload.box.com/api/2.0/files/upload_sessions/${sessionId}/commit`,
        { parts },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            Digest: `sha=${fullSha}`,
          },
        }
      );

      const File = commitResponse.entries[0];
      const { file_url, file_id } = await generateUrl(File.id, fileName);

      if (file_url && file_id) {
        const [min, max] = sliderValues;
        const minTime = sliderValueToVideoTime(videoDuration, min);
        const maxTime = sliderValueToVideoTime(videoDuration, max);

        const config = {
          host: `${path}`,
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": `${path}`,
            Authorization: `Bearer ${token}`,
          },
        };

        const body = {
          startTime: minTime,
          endTime: maxTime,
          boxUrl: file_url,
          boxId: file_id,
          userId: user?._id,
          contestId: contestId,
          platform: "web",
        };

        const response = await axios.post(
          `${path}/v2/contest/createSubmission`,
          body,
          config
        );
        socket.emit("contest-submitted", user);
        dispatch(setContribution(contestId));

        if (response.status === 200) {
          toast.success("Video Uploaded Successfully!");
          setIsVideoUploaded(true);
          setSubmission(response.data.submission);
          if (ENV === "prod") {
            ReactGA.event("submission_done", {
              user_id: user._id,
              submission_id: response.data.submission._id,
            });
            fbq("trackCustom", "submission_done", {
              user_id: user._id,
              submission_id: response.data.submission._id,
              email: user?.email || "",
              currency: "INR",
              value: contestFee,
            });
          }
        }
      }
    } catch (error) {
      toast.error("Error uploading video, please try again!");
      console.error("Error uploading video: " + JSON.stringify(error));
    }
  };

  const DirectBoxUpload = async () => {
    const limit = 50 * 1024 * 1024; // 50 MB in bytes
    const { uploadSpeed } = uploadConfig;

    if (!videoFile.size) {
      toast.error("Error getting file size, try again!");
      return;
    }
    if (ENV === "prod") {
      trackEvent(EventTypes.UPLOAD_SPEED, { uploadSpeed })
    }
    setSubmissionUploading(true);

    try {
      let fileName = `FeedAnts_UsrId_${user._id}_CntstId_${contestId}_${Date.now()}.mp4`;

      if (videoFile.size < limit) {
        return await DirectSingleUpload(videoFile, fileName);
      } else {
        return await DirectChunkUpload(videoFile, fileName);
      }
    } catch (error) {
      console.log("Error getting file stats:", JSON.stringify(error));
      throw new Error("Error during box upload: " + error);
    } finally {
      setSubmissionUploading(false);
      setFinalPercentage(0);
    }
  }

  const DiscountText = ({ oldFee, newFee }) => {
    return <div className="flex flex-row items-center gap-1">
      <span>Pay</span>
      <div>
        <span className="text-[#008080] text-[12px] line-through rounded-l-lg rounded-r-lg bg-white px-1">₹{oldFee}</span>
      </div>
      <span>{`₹${newFee} to Submit`}</span>
    </div>
  }

  const renderUploadAction = () => {
    if (submission && submission.mediaUrl) {
      if (submission.paid) {
        return (
          <button
            disabled={false}
            onClick={() => redirectToStore("submission_upload_modal")}
            className={`flex items-center justify-center bg-[#008080] rounded-lg p-3 mt-2 w-full text-white text-lg font-medium`}>
            Download App To Check Results
          </button>
        );
      } else {
        let finalFee, registerFee;
        if(paymentType === "Slotpaid") {
          registerFee = Math.round(contestFee * (slotFeePercentage/100));
          finalFee = contestFee - registerFee;
        }
        return (
          <div className="flex flex-col gap-0.5 mt-2">
            {paymentType !== "Slotpaid" && activeDiscount && <div className="relative flex flex-row items-center justify-center gap-x-1 rounded-t-lg pt-2 pb-3 -bottom-2 z-10 bg-[linear-gradient(to_right,_#e6feef_0%,_#cefde0_5%,_#AFFCCD_50%,_#cefde0_95%,_#e6feef_100%)]">
              <img src={PercentageBadge} alt="Percentage Icon" className="size-4" />
              <p className="text-[#024D4D] text-[14px] font-gilroy-semibold">{activeDiscount.text}</p>
            </div>}
            {paymentType === "Slotpaid" &&
            <div className="relative flex flex-row items-center justify-center rounded-t-lg pt-2 pb-3 -bottom-2 z-10">
              <p className="text-[#024D4D] text-[14px] font-gilroy-semibold">{`Paid ${activeDiscount? activeDiscount.newSlotRegisterFee :registerFee} INR, pay the remaining amount. ${activeDiscount? `(${activeDiscount.percentage}% applied)`: ""}`}</p>
            </div>}
            <button
              onClick={async () => {
                if(paymentType === "Slotpaid") {
                  await slotFinalPaymentHandler()
                } else {
                  await paymentHandler()
                }
              }}
              disabled={processingPayment}
              style={{
                backgroundColor: processingPayment ? "#6ea9a8" : "#008080",
              }}
              className={`flex items-center justify-center rounded-lg p-3 w-full text-white text-lg font-medium z-20`}>
              {function(){
                if(processingPayment) {
                  return "Processing Payment"
                } 
                if(paymentType === "Slotpaid") {
                  if(activeDiscount) {
                    return <DiscountText oldFee={finalFee} newFee={activeDiscount.newSlotFinalFee} />
                  } else {
                    return `Pay ₹${finalFee} to Submit`
                  }
                } else {
                  if(activeDiscount) {
                    return <DiscountText oldFee={contestFee} newFee={activeDiscount.newFee} />
                  } else {
                    return `Pay ₹${contestFee} to Submit`
                  }
                } 
              }()}
            </button>
          </div>
        );
      }
    } else {
      return (
        <>
          <label
            className={`flex items-center justify-center rounded-lg px-2 py-3 mt-2 w-full text-white text-lg font-gilroy-medium cursor-pointer ${submissionUploading ? "bg-[#6ea9a8] cursor-not-allowed" : "bg-[#008080]"
              }`}
          >
            <input
              type="file"
              accept="video/*"
              onChange={(e) => setVideoFile(e.target.files[0])}
              className="hidden"
              disabled={submissionUploading}
            />
            Change Video
          </label>

          {submissionUploading ? (
            <button
              disabled={true}
              className={`flex items-center justify-center bg-[#008080] rounded-lg px-2 py-3 mt-2 w-full text-white text-lg font-gilroy-medium`}>
              {`Uploading ${finalPercentage}%`}
            </button>
          ) : (
            <button
              disabled={isVideoLengthError}
              style={{
                backgroundColor: isVideoLengthError ? "#6ea9a8" : "#008080",
              }}
              className={`flex items-center justify-center rounded-lg px-2 py-3 mt-2 w-full text-white text-lg font-gilroy-medium gap-2`}
              onClick={DirectBoxUpload}>
              <LockIcon className="size-5 " /> Secure Upload
            </button>
          )}
        </>
      );
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={[]}
      title={videoFile ? <><div className="font-gilroy-medium text-lg text-[#0D1C2E]"><p>Secure upload & payment</p><p className="font-gilroy-regular text-xs">Final submission video length should be atleast 2 mins</p></div></> : <span className="font-gilroy-medium text-lg text-[#0D1C2E]">Guidelines</span>}>
      {videoFile ? (
        <>
          <div className="relative">
            <VideoPlayer
              key={videoFile?.name}
              src={URL.createObjectURL(videoFile)}
              onPlayerChange={(videoPlayer) => {
                videoPlayerRef.current = videoPlayer;
              }}
              onChange={(videoPlayerState) => {
                const endTime = sliderValueToVideoTime(
                  videoPlayerState.duration,
                  sliderValues[1]
                );
                if (videoPlayerState?.currentTime >= endTime) {
                  videoPlayerRef.current.pause();
                }
                if (
                  !isNaN(videoPlayerState?.duration) &&
                  videoDuration !== videoPlayerState.duration
                ) {
                  setVideoDuration(videoPlayerState.duration);
                  setIsVideoLengthError(
                    videoPlayerState.duration > maxVideoLength * 60
                  );
                }
              }}
              startTime={sliderValueToVideoTime(videoDuration, sliderValues[0])}
            />
            {videoFile && !submissionUploading && !submission?.mediaUrl && (
              <div
                className="p-2 bg-red-100 absolute top-2 right-2 rounded-full"
                onClick={removeVideoHandler}
              >
                <DeleteOutlineOutlinedIcon className="size-4 text-red-700" />
              </div>
            )}
          </div>
          <p className="py-2 w-full text-center text-sm text-[[#707C97]] font-gilroy-semibold">
            {function(){
              if(paymentType === "Slotpaid") {
                const left =
                  participationLimit - registeredLength;

                return left > 0
                  ? <>Only <span className="text-[#008080]">{`${left} ${left === 1 ? "slot" : "slots"} left`}</span> hurry up!</>
                  : "All slots filled.";
              }

              const left =
                participationLimit - (submissionInfo?.paidCount ?? 0);

              return left > 0
                ? <>Only <span className="text-[#008080]">{`${left} left`}</span> hurry up!</>
                : "No spots left.";
            }()}
          </p>
          {isVideoLengthError && (
            <h3 className="mb-2 w-full text-center font-gilroy-medium text-red-600">{`Video length cannot be longer than ${maxVideoLengthInMinutes}`}</h3>
          )}
          <Slider
            disabled={isVideoUploaded || submissionUploading}
            value={sliderValues}
            marks={{ 0: { label: "0:00", style: { left: "2%" } }, 100: { label: formatter(100), style: { left: "98%" } } }}
            tooltip={{ formatter }}
            range={{ draggableTrack: true }}
            defaultValue={[0, 100]}
            onChange={(values) => SilderCal(values)}
            styles={{
              track: {
                background: "transparent",
              },
              tracks: {
                background: `#62A588`,
              },
            }}
          />
          {renderUploadAction()}
          <div className="flex items-center gap-2 justify-center text-[#707C97] font-gilroy-medium mt-4">
            <p>Powered By </p><img src={RazorpayText} className="h-4 w-auto" alt="razorpay" /><p>• SSL Secured</p>
          </div>
        </>
      ) : (
        <div className=" flex flex-col gap-y-4 gap-x-2">
          <div className=" flex flex-col gap-2 my-4">
            {submissionGuidelines.map((item) => {
              const IconComponent = item?.icon;
              return (
                <div key={item?.text} className="flex gap-3 items-center">
                  <span className="p-2 bg-gray-100 rounded-full text-[#0D1C2E]">
                    {IconComponent && <IconComponent fontSize="small" />}
                  </span>
                  <p className="font-gilroy-medium font-medium text-lg text-[#0D1C2E]">
                    {item?.text}
                  </p>
                </div>
              );
            })}
          </div>
          <div>
            <h2 className="mb-2 font-lg font-gilroy-medium text-[#0D1C2E]">Choose a File to Upload</h2>
            <input
              className="text-lg font-medium text-[#0D1C2E]"
              type="file"
              accept="video/*"
              onChange={(e) => setVideoFile(e.target.files[0])}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SubmissionUploadModal;
